module.exports = __webpack_public_path__ + "static/media/secondary-logo1.d60bdbdf.jpg";